import React from 'react'
import { Section, Link, Image } from 'newComponents'
import twitterIcon from '../../../images/blog/twitter.svg'

import './styles.scss'

const AuthorHeader = (props) => {
  const { name, bio, image, twitter } = props
  // content checks
  const nameHtml = name?.html
  const bioHtml = bio?.html
  const hasImage = image?.url
  const hasTwitter = twitter?.url

  return (
    <Section className="author-header">
      <div className="author-header-container">
        <div className="author-header-text">
          <span className="author-header-tagline">AUTHOR</span>
          {nameHtml && <div dangerouslySetInnerHTML={{ __html: nameHtml }} className="author-header-title" />}
          {bioHtml && <div dangerouslySetInnerHTML={{ __html: bioHtml }} className="author-header-description" />}
        </div>
        <div className="author-header-img-twitter">
          {hasImage && <Image className="author-header-image" image={image} />}
          {hasTwitter && (
            <Link to={hasTwitter} className="author-header-twitter">
              <Image image={twitterIcon} />
              <span className="author-header-follow">Follow</span>
            </Link>
          )}
        </div>
      </div>
    </Section>
  )
}

export default AuthorHeader
